import React from "react";
import { useNavigate } from "react-router-dom";

import { RoughCircle } from "../kits/DesignKit";    



export default function RoughAvatarLink({
  to = "/about",
  imgSrc = "/images/den.png",
  alt = "Denis Bitter",
  className = "",
  mobileSize = 90,
  desktopSize = 101,
  cropClassName = "object-[80%_20%]",
  ringColor = "#AC8E66",
  ringStrokeWidth = 0.7,
  ringRoughness = 0.1,
  onClick,
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    onClick?.(e);
    navigate(to);
    // sofort nach oben (dein Pattern)
    setTimeout(() => window.scrollTo({ top: 0, behavior: "instant" }), 0);
  };

  

  return (
    <div
      onClick={handleClick}
      className={`relative w-24 h-24 md:w-28 md:h-28 mx-auto mb-6 block cursor-pointer ${className}`}
      aria-label={`Zu ${to}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " " ? handleClick(e) : null)}
    >
      {/* Ring Mobile */}
      <div className="absolute inset-0 flex items-center shrink-0 justify-center md:hidden">
        <RoughCircle
          size={mobileSize}
          color={ringColor}
          strokeWidth={ringStrokeWidth}
          roughness={ringRoughness}
        />
      </div>

      {/* Ring Desktop */}
      <div className="absolute inset-0 items-center justify-center hidden md:flex">
        <RoughCircle
          size={desktopSize}
          color={ringColor}
          strokeWidth={ringStrokeWidth}
          roughness={ringRoughness}
        />
      </div>

      {/* Avatar */}
      <div className="absolute inset-2 rounded-full bg-gradient-to-br from-brand to-brand flex items-center justify-center overflow-hidden">
        <img
          src={imgSrc}
          width={256}
          height={256}
          alt={alt}
          className={`w-full h-full object-cover ${cropClassName}`}
          loading="lazy"
        />
      </div>
    </div>
  );
}
